function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

export function getBoxShadow(placement, color) {
  if (!color) return undefined;

  if (placement.includes("top")) {
    return "2px 2px 2px 0 " + color;
  }

  if (placement.includes("bottom")) {
    return "-1px -1px 1px 0 " + color;
  }

  if (placement.includes("right")) {
    return "-1px 1px 1px 0 " + color;
  }

  if (placement.includes("left")) {
    return "1px -1px 1px 0 " + color;
  }

  return undefined;
}
var transformEnum = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
};
export var toTransformOrigin = placement => transformEnum[placement];
export var getArrowStyles = options => {
  var {
    arrowSize,
    popperArrowStyles = {},
    placement
  } = options;

  var styles = _extends({}, popperArrowStyles, {
    width: arrowSize,
    height: arrowSize,
    zIndex: -1
  });

  var offsetAdjust = -(arrowSize / 2);
  if (placement.startsWith("top")) styles.bottom = offsetAdjust;
  if (placement.startsWith("bottom")) styles.top = offsetAdjust;
  if (placement.startsWith("left")) styles.right = offsetAdjust;
  if (placement.startsWith("right")) styles.left = offsetAdjust;
  return styles;
};
//# sourceMappingURL=popper.utils.js.map